import styled from 'styled-components'

export const RentContractFileWrap = styled.div``
